import type { FormFieldFeedback } from "@tellescope/types-models";
import { type FormTranslationMap, resolveFormTranslation } from "./utils";

export interface FieldFeedbackProps {
  feedback?: FormFieldFeedback[];
  value: unknown;
  translations?: FormTranslationMap;
}

/**
 * Renders the author-configured `field.feedback` messages whose `ifEquals` matches the
 * current answer — a scalar equality, or membership for multi-select answers.
 */
export const FieldFeedback = ({ feedback, value, translations }: FieldFeedbackProps) => {
  const matched = (feedback ?? []).filter(
    ({ ifEquals }) => ifEquals === value || (Array.isArray(value) && value.includes(ifEquals))
  );

  if (matched.length === 0) return null;

  return (
    <div className="flex flex-col gap-1">
      {matched.map(({ ifEquals, display }) => (
        <p key={`${ifEquals}:${display}`} className="text-destructive text-base">
          {resolveFormTranslation(display, translations)}
        </p>
      ))}
    </div>
  );
};
